import { FormControl, UntypedFormGroup } from '@angular/forms';
import { Operation } from '@app/core/stingray-api/models';
import _ from 'lodash';


export function getFormGroupValue(group: UntypedFormGroup): any {
  // If all properties are null, return null
  if (Object.keys(group.controls).every(x => _.isNull(group.controls[x].value))) {
    return null;
  }

  return group.value;
}

export function convertFormGroupToPatchOperations(group: UntypedFormGroup): Operation[] {

  // Some magic to build patch operations
  const operations: Operation[] = [];
  Object.keys(group.controls).forEach((key: string) => {

    const control = group.controls[key];
    let path = null;
    let value = null;

    if (control instanceof UntypedFormGroup) {
      path = key;
      value = getFormGroupValue(control as UntypedFormGroup);
    } else if (control instanceof FormControl) {
      path = key;
      value = (control as FormControl).value;
    }

    if (path) {
      operations.push({
        path: path,
        value: value,
        op: 'replace'
      });
    }
  });

  return operations;
}
